export enum UIElementEnum {
    unknown = 0,
    user,
    rbBlock,
    calc,
    dec,
    lb,
    img,
    lv,
    html,
    pers,
    time,
    barcode,
    sig,
    tb,
    wnl,
    bp,
    caseuser,
    rbil,
    rb,
    datetime,
    link,
    score,
    docref,
    multi,
    ta,
    btn,
    dd,
    rich,
    cb,
    ms,
    include,
    date,
    rf,
    pa,
    ph
}